import { ReactNode } from 'react';
import { Loader2 } from 'lucide-react';

/**
 * Spinner / overlay de chargement — remplace antd Spin.
 *
 * <Spin spinning={loading}> ...children... </Spin>
 */
const Spin = (props: { spinning: boolean; children: ReactNode; size?: number }) => (
    <div className="relative">
        {props.children}
        {props.spinning && (
            <div className="absolute inset-0 z-40 flex items-center justify-center bg-[var(--eb-surface)]/70 backdrop-blur-[2px] rounded-inherit">
                <Loader2 size={props.size || 32} className="animate-spin text-[var(--eb-primary)]" />
            </div>
        )}
    </div>
);

export default Spin;
